import React from 'react';

import ReservationsComponent from '../../components/reservation/reservations.component';

const ReservationPage = () => (
  <ReservationsComponent />
);

export default ReservationPage;
